const products = [
  {
    id: 'r1',
    name: 'Tapis tufté standard',
    category: 'Tapis',
    short: 'Tufté, plusieurs coloris, tailles personnalisables.',
    moq: '200 pcs',
    image: '/assets/tapis.svg',
    description: 'Tapis tufté avec fibres durables, options OEM.'
  },
  {
    id: 'r2',
    name: 'Couette microfibre hiver',
    category: 'Couettes',
    short: 'Chaude et légère, grammage au choix.',
    moq: '300 pcs',
    image: '/assets/couette.svg',
    description: 'Garnissage microfibre, enveloppe douce, différentes tailles.'
  },
  {
    id: 'r3',
    name: 'Sac shopping renforcé',
    category: 'Sacs',
    short: 'Réutilisable, grande capacité, logo personnalisé.',
    moq: '1000 pcs',
    image: '/assets/sac.svg',
    description: 'Sac en PP non-tissé ou toile, anses renforcées.'
  },
  {
    id: 'r4',
    name: 'Tapis tissé premium',
    category: 'Tapis',
    short: 'Finitions haut de gamme pour retail ou hôtellerie.',
    moq: '150 pcs',
    image: '/assets/tapis.svg',
    description: 'Tissé jacquard, motifs personnalisables, contrôle qualité strict.'
  }
];

export default products;
